import { postTiper, identifyTiper } from "../api/tiper";
import { KTCookie } from "./cookie";
import { CONSENT_VERSION } from "./index";

const COOKIE_NAME = "tipifyCookie";
const COOKIE_OPTIONS = {
  expires: new Date("9999-12-31T23:59:59.999Z"),
  path: "/",
};

/**
 * Devuelve el id del tiper de la cookie o crea uno anónimo nuevo.
 * Lanza error si la creación falla (no silencencia fallos).
 */
export async function ensureTiperId() {
  const cookie = KTCookie.getCookie(COOKIE_NAME);
  if (cookie) {
    return cookie;
  }

  const res = await postTiper();
  const tiperId = res?.data?.id;
  if (!tiperId) {
    throw new Error("No se recibió id al crear el tiper");
  }

  KTCookie.setCookie(COOKIE_NAME, tiperId, COOKIE_OPTIONS);
  return tiperId;
}

export function normalizeEmail(email) {
  return email?.trim().toLowerCase() || "";
}

/**
 * Identifica al tiper por email en el backend (pantalla de éxito): fusiona el
 * anónimo de la cookie con el que ya tenga ese email, guarda el consentimiento
 * y enlaza la propina. Actualiza la cookie con el id definitivo y lo devuelve.
 */
export async function identifyTiperForTip({
  email,
  tipId,
  languageCode,
  consentType = "comunicaciones",
  businessId,
}) {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail || !normalizedEmail.includes("@")) {
    throw new Error("Email inválido");
  }

  const cookie = KTCookie.getCookie(COOKIE_NAME);
  const res = await identifyTiper({
    email: normalizedEmail,
    tiperId: cookie || undefined,
    tipId,
    language: languageCode,
    consent: {
      tipo: consentType,
      version: CONSENT_VERSION,
      origen: "web_success",
      business: businessId || undefined,
    },
  });

  const tiperId = res?.data?.tiperId;
  if (!tiperId) {
    throw new Error("No se recibió id al identificar el tiper");
  }
  if (tiperId !== cookie) {
    KTCookie.setCookie(COOKIE_NAME, tiperId, COOKIE_OPTIONS);
  }
  return tiperId;
}
